import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const ITEM_FIELDS = gql`
  fragment TagReviewItemFields on TagReviewItemV2 {
    id
    batchId
    entityType
    entityId
    status
    suggestedTags
    acceptedTags
    messageSetId
    messageSetTitle
    categories
    characters
    listingTitle
    listingDescription
    listingIconUrl
    popularityScore
    rejectionReason
    createdAt
    queuedAt
    processedAt
    error {
      type
      message
    }
  }
`

const APPROVE_ITEM = gql`
  mutation ApproveTagReviewItem($input: ApproveTagReviewItemInputV2!) {
    approveTagReviewItemV2(input: $input) {
      ... on TagReviewItemV2 {
        ...TagReviewItemFields
      }
      ... on TagReviewItemErrorV2 {
        type
        errorMessage: error
      }
    }
  }
  ${ITEM_FIELDS}
`

const REJECT_ITEM = gql`
  mutation RejectTagReviewItem($input: RejectTagReviewItemInputV2!) {
    rejectTagReviewItemV2(input: $input) {
      ... on TagReviewItemV2 {
        ...TagReviewItemFields
      }
      ... on TagReviewItemErrorV2 {
        type
        errorMessage: error
      }
    }
  }
  ${ITEM_FIELDS}
`

const REVERT_ITEM = gql`
  mutation RevertTagReviewItem($input: RevertTagReviewItemInputV2!) {
    revertTagReviewItemV2(input: $input) {
      ... on TagReviewItemV2 {
        ...TagReviewItemFields
      }
      ... on TagReviewItemErrorV2 {
        type
        errorMessage: error
      }
    }
  }
  ${ITEM_FIELDS}
`

const UPDATE_TAGS = gql`
  mutation UpdateTagReviewItemTags($input: UpdateTagReviewItemTagsInputV2!) {
    updateTagReviewItemTagsV2(input: $input) {
      ... on TagReviewItemV2 {
        ...TagReviewItemFields
      }
      ... on TagReviewItemErrorV2 {
        type
        errorMessage: error
      }
    }
  }
  ${ITEM_FIELDS}
`

const UNREJECT_ITEM = gql`
  mutation UnRejectTagReviewItem($input: UnRejectTagReviewItemInputV2!) {
    unRejectTagReviewItemV2(input: $input) {
      ... on TagReviewItemV2 {
        ...TagReviewItemFields
      }
      ... on TagReviewItemErrorV2 {
        type
        errorMessage: error
      }
    }
  }
  ${ITEM_FIELDS}
`

const APPROVE_ALL_PENDING = gql`
  mutation ApproveAllPendingTagReviewItems($input: ApproveAllPendingTagReviewItemsInputV2!) {
    approveAllPendingTagReviewItemsV2(input: $input) {
      ...TagReviewItemFields
    }
  }
  ${ITEM_FIELDS}
`

export const useApproveTagReviewItem = () =>
  useMutation<any, { input: { id: string; batchId: string; acceptedTags: string[] } }>(APPROVE_ITEM)

export const useRejectTagReviewItem = () =>
  useMutation<any, { input: { id: string; batchId: string; rejectionReason?: string } }>(REJECT_ITEM)

export const useRevertTagReviewItem = () =>
  useMutation<any, { input: { id: string; batchId: string } }>(REVERT_ITEM)

export const useUnRejectTagReviewItem = () =>
  useMutation<any, { input: { id: string; batchId: string } }>(UNREJECT_ITEM)

export const useUpdateTagReviewItemTags = () =>
  useMutation<any, { input: { id: string; batchId: string; acceptedTags: string[] } }>(UPDATE_TAGS)

export const useApproveAllPendingTagReviewItems = () =>
  useMutation<any, { input: { batchId: string; itemIds: string[] } }>(APPROVE_ALL_PENDING)

const RETRY_ITEM = gql`
  mutation RetryTagReviewItem($input: RetryTagReviewItemInputV2!) {
    retryTagReviewItemV2(input: $input) {
      ... on TagReviewItemV2 {
        ...TagReviewItemFields
      }
      ... on TagReviewItemErrorV2 {
        type
        errorMessage: error
      }
    }
  }
  ${ITEM_FIELDS}
`

export const useRetryTagReviewItem = () =>
  useMutation<any, { input: { id: string; batchId: string } }>(RETRY_ITEM)
